<template>
  <div class="background">
    <div class="main-body">
      <h1 style="padding-bottom: 12px">修改密码</h1>
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="旧密码" prop="oldPassword">
          <Input
            type="password"
            v-model="formItem.oldPassword"
            @on-blur="validatPasswordMethod"
            placeholder="输入旧密码"
          />
        </FormItem>
        <FormItem label="新密码" prop="password">
          <Input
            type="password"
            @on-enter="handleSubmit('formItem')"
            v-model="formItem.password"
            placeholder="输入新密码"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">修改</Button>
        </FormItem>
      </Form>
      <div class="tip">注：首次登陆需要重置初始密码</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "changePassword",
  data() {
    const validtNewPassword = (rule, value, cb) => {
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,20}$/;
      if (!reg.test(value)) {
        cb(new Error("密码必须由数字和字母组成"));
      } else {
        cb();
      }
    };
    return {
      formItem: {
        oldPassword: null,
        password: null,
      },
      ruleValidate: {
        oldPassword: [
          { required: true, message: "请填写旧密码", trigger: "blur" },
          {
            type: "string",
            min: 8,
            message: "密码必须大于8位数",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请填写新密码", trigger: "blur" },
          {
            type: "string",
            min: 8,
            message: "密码必须大于8位数",
            trigger: "blur",
          },
          {
            validator: validtNewPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      logout: "auth/logoutAction",
      validatPassword: "user/validatPasswordAction",
      resetMyPassword: "auth/resetMyPasswordAction",
    }),
    async validatPasswordMethod() {
      const password = this.formItem.oldPassword;
      const id = this.user._id;
      if (password) {
        try {
          await this.validatPassword({
            id,
            password,
          });
        } catch (error) {
          this.$Message.error(`${error}`);
        }
      }
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          if (this.formItem.password !== this.formItem.oldPassword) {
            await this.resetMyPassword({
              password: this.formItem.password,
              oldPassword: this.formItem.oldPassword,
            });
            this.$Message.success("修改成功!");
            this.$router.push("/home/task");
          } else {
            this.$Message.error("新旧密码不能重复!");
          }
        } else {
          this.$Message.error("修改失败!");
        }
      });
    },
    async logoutFunc() {
      try {
        await this.logout();
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
      this.$router.push("/");
    },
  },
};
</script>

<style scoped lang="stylus">
.background
  width 100%
  height 100vh
  background-color #425384
  overflow hidden
  display flex
  justify-content center
  align-items center

.main-body
  width 400px
  height 400px
  background-color white
  border-radius 6px
  padding 12px

  .tip
    color #D90013
    font-size 15px
</style>